/* The assistant's entry on a catalog and its window (app#397). Tokens only. */

/* "Ask GAC AI", beside Buy / Rent: the catalog's one action on its first screen — the accent with
   black letters (brand, «Акцент: лайм»), a whole touch target high, on one line. */
.pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
  min-height: var(--gac-control-touch-target);
  padding: 0 var(--gac-space-md);
  border: none;
  border-radius: var(--gac-radius-pill);
  background: var(--gac-accent);
  color: var(--gac-accent-ink);
  font-family: var(--gac-font-text);
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
}

.pill:hover {
  background: var(--gac-accent-hover);
}

.pill:focus-visible {
  outline: var(--gac-control-focus-ring) solid var(--gac-text-primary);
  outline-offset: 2px;
}

/* Under 360px the label is the window's name alone (spec §3, row и): "Ask" is not displayed, so it
   is not read either, and the pill stays on the row of Buy / Rent down to 320px. */
@media (max-width: 359px) {
  .ask {
    display: none;
  }

  .pill {
    padding: 0 var(--gac-space-sm);
  }
}

/* The phone's sheet: almost the whole screen, as tall as the screen has room for — less a gap of
   air, the rise of the dialog's badge above the sheet and the dialog's own chrome (16 + 48 + 128,
   the arithmetic of the filters' sheet in `CatalogFilters`) — so the field stays at the bottom and
   the conversation never runs off the top. `dvh` where the browser has it: a phone's address bar is
   not screen. */
.sheet {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 192px);
  height: calc(100dvh - 192px);
  min-height: 0;
}

/* The laptop's panel: 400px on the right, under the top bar, over the catalog's right side — the
   catalog is neither squeezed nor dimmed, and stays in reach. */
.panel {
  position: fixed;
  top: var(--gac-nav-height);
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  width: 400px;
  max-width: 100vw;
  padding: var(--gac-space-md);
  box-sizing: border-box;
  background: var(--gac-surface-raised-solid);
  border-left: 1px solid var(--gac-line-border);
  box-shadow: var(--gac-shadow-modal);
}

.panel:focus {
  outline: none;
}
